"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStyle = void 0;
const styled_components_1 = require("styled-components");
exports.GlobalStyle = (0, styled_components_1.createGlobalStyle) `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&family=Work+Sans:wght@400;500;600&display=swap');

  /* font-family: 'Poppins', sans-serif;
     font-family: 'Work Sans', sans-serif; */

  * {
    margin: 0;
    padding: 0;
    outline-color: ${(props) => props.theme.action004};
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smooyhing: grayscale;

    [data-lift='lft-iconbase'] { 
      box-sizing: unset;
    }
  }

  :after,
  :before {
    box-sizing: border-box;
  }

  html,
  body,
  #root {
    height: 100%;
  }

  body {
    margin: 0px;
    padding: 0;
    display: block;
    justify-content: initial;
    align-items: initial;
    min-height: initial;
    background-color: ${(props) => props.theme.white};
  }

  button {
    cursor: pointer;
  }

  img {
    width: 100%;
  }

  .ico-8 {
    width: 8px;
    height: 8px;
  }

  .ico-24 {
    width: 24px;
    height: 24px;
  }

  .ico-48 {
    width: 48px;
    height: 48px;
  }

  .ico-54 {
    width: 54px;
    height: 54px;
  }

  .formatTextEllipse {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .spcBt16 {
    margin: 0 0 16px;
  }

  .spcBt24 {
    margin: 0 0 24px;
  }

  .somenteLeitorDeTela {
    position: absolute;
    border: none;
    background: transparent;
    border-radius: 0;
    color: transparent;
    width: 0;
    height: 0;
    overflow: hidden;
  }
`;
